import { render, staticRenderFns } from "./ordenescompra.vue?vue&type=template&id=12857f24"
import script from "./ordenescompra.vue?vue&type=script&lang=js"
export * from "./ordenescompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports